module.exports = __webpack_public_path__ + "static/implant02-96c9a6537333ea014f7ef70f04973a74.jpg";